import { render, staticRenderFns } from "./QueueList.vue?vue&type=template&id=4b55406f&"
import script from "./QueueList.vue?vue&type=script&lang=js&"
export * from "./QueueList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports